export default {
  isEmailValid: (email: string): boolean => {
    return /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i.test(email)
  },
  minimumLength: (value: string, length: number): boolean => {
    return value.trim().length >= length
  },
  hasLowerLetter: (value: string): boolean => {
    return value.toUpperCase() !== value
  },
  hasUpperLetter: (value: string): boolean => {
    return /[A-Z]/.test(value)
  },
  hasNumber: (value: string): boolean => {
    return /\d/.test(value)
  },
  hasSpecialCharacter: (value: string): boolean => {
    return /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(value)
  },
  isPresent: (value: string): boolean => {
    return value.trim().length > 0
  }
}
